import React, { useCallback, useMemo, useState } from 'react'

import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import { Button, Flex } from 'antd'
import { Modal } from 'govwell-ui'
import { UserDataFragment } from 'types/graphql'

import StaffUserSelect from 'src/components/Selects/StaffUserSelect'
import { useGetAIStaffMembersQuery, useUpdateUserIsAIStaffMemberMutation } from 'src/fetch/users'

type Props = {
  onClose: () => void
}

const AddTeamMemberModal = ({ onClose }: Props) => {
  const [selectedUser, setSelectedUser] = useState<UserDataFragment | undefined | null>(undefined)
  const { mutateAsync: updateUserIsAIStaffMember } = useUpdateUserIsAIStaffMemberMutation()
  const { refetch } = useGetAIStaffMembersQuery()

  const handleUserChange = useCallback((user: UserDataFragment | undefined | null) => {
    setSelectedUser(user)
  }, [])

  const handleSubmit = useCallback(async () => {
    if (!selectedUser) {
      return
    }

    await updateUserIsAIStaffMember({
      id: selectedUser.id,
      isAIStaffMember: true,
    })
    await refetch()
    onClose()
  }, [selectedUser, updateUserIsAIStaffMember, refetch, onClose])

  const isSubmitDisabled = useMemo(() => !selectedUser, [selectedUser])

  return (
    <Modal onClose={onClose}>
      <Modal.Header icon={faPlus}>Add Team Member</Modal.Header>
      <Modal.Content>
        <Flex vertical gap="16px">
          <StaffUserSelect
            type="AnyUserInOrganization"
            label="Select User"
            placeholder="Search for users to add to the AI team"
            value={selectedUser}
            onValueChange={handleUserChange}
            isClearable
            isMultiSelect={false}
          />
        </Flex>
      </Modal.Content>
      <Modal.Footer>
        <Button onClick={onClose}>Cancel</Button>
        <Button type="primary" onClick={handleSubmit} disabled={isSubmitDisabled}>
          Add Member
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(AddTeamMemberModal)
